"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[57616],{

/***/ 802705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ RefreshOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const RefreshOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.3719 2.48965C19.3498 2.07603 18.9965 1.75869 18.5829 1.78085C18.1693 1.80301 17.8519 2.15628 17.8741 2.5699L17.9659 4.28366C16.3174 3.00646 14.2461 2.24608 12 2.24608C6.61584 2.24608 2.25 6.61081 2.25 11.9961C2.25 17.3814 6.61584 21.7461 12 21.7461C17.3852 21.7461 21.75 17.3813 21.75 11.9961C21.75 11.3831 21.6938 10.7832 21.5854 10.2C21.5097 9.79279 21.1182 9.52402 20.7109 9.59971C20.3037 9.67541 20.0349 10.0669 20.1106 10.4741C20.2022 10.967 20.25 11.4751 20.25 11.9961C20.25 16.5529 16.5568 20.2461 12 20.2461C7.44416 20.2461 3.75 16.5528 3.75 11.9961C3.75 7.43935 7.44416 3.74608 12 3.74608C13.9066 3.74608 15.6616 4.39206 17.0582 5.47795L15.1388 5.52197C14.7247 5.53147 14.3967 5.87486 14.4062 6.28897C14.4157 6.70307 14.7591 7.03107 15.1732 7.02158L18.8362 6.93758C19.039 6.93293 19.2313 6.84629 19.3692 6.69745C19.5071 6.5486 19.5788 6.35025 19.5679 6.14765L19.3719 2.48965Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 123579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ BuildPcItem; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(797864);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(865237);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(650983);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(995667);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(179185);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(621655);
/* harmony import */ var _BuildPcNumberStepper_BuildPcNumberStepper_es_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(260613);
/* harmony import */ var _Common_ProductPrice_ProductPrice_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(770024);
/* harmony import */ var _Common_ProductGifts_ProductGifts_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(811850);
/* harmony import */ var _Common_ProductName_ProductName_es_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73586);









var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Anchor = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.a */ .z.a`
  color: unset;
  text-decoration: unset;
`;
const StyledCard = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Card */ .Z)`
  padding: 1.5rem 1rem;
  transition: box-shadow 0.2s ease-in-out;
  &:hover {
    box-shadow: 0.1rem 0.1rem 0.5rem 0.1rem rgba(0, 0, 0, 0.08);
  }
`;
const StyledCol = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Col */ .J)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
const StyledPrice = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_Common_ProductPrice_ProductPrice_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductPrice */ .j)`
  min-height: auto;
`;
const Title = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-weight: 500;
`;
const NameWrapper = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Col */ .J)`
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  display: flex;
  align-items: center;
`;
const StyledProductGifts = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_Common_ProductGifts_ProductGifts_es_js__WEBPACK_IMPORTED_MODULE_5__/* .ProductGifts */ .W)`
  margin-top: 5px;
`;
const SKU = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span`
  color: #757575;
  font-size: 0.8125rem;
`;
const StyledButton = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .z)`
  height: 32px;
  width: 60px;
  padding: 0;
`;
const StyledButtonDelete = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT)(({ theme }) => `
  margin-top: 12px;
  cursor: pointer;
  color: ${theme == null ? void 0 : theme.colors.link500};
  :hover {
    color: ${theme == null ? void 0 : theme.colors.error500};
  }
`);
const BuildPcItem = (_a) => {
  var _b = _a, {
    title,
    product,
    icon = "",
    onIncrease,
    onDecrease,
    onClick,
    actionText,
    quantity,
    setQuantity,
    showDeleteButton = false,
    onDelete
  } = _b, props = __objRest(_b, [
    "title",
    "product",
    "icon",
    "onIncrease",
    "onDecrease",
    "onClick",
    "actionText",
    "quantity",
    "setQuantity",
    "showDeleteButton",
    "onDelete"
  ]);
  var _a2, _b2;
  const disableButton = () => {
    var _a3;
    if (product && !((_a3 = product == null ? void 0 : product.price) == null ? void 0 : _a3.latestPrice))
      return true;
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_8__/* .Row */ .X, null, title && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCol, {
    col: 1.5
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, null, title)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCol, {
    col: 1.5
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_9__/* .LazyImage */ .w, {
    imageWidth: 150,
    src: (product == null ? void 0 : product.imageUrl) || icon,
    onClick: () => {
      if (!product)
        onClick == null ? void 0 : onClick();
    },
    border: true,
    borderRadius: 8,
    contain: true
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(NameWrapper, null, product ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, {
    href: (_b2 = (_a2 = product.link) == null ? void 0 : _a2.as) == null ? void 0 : _b2.pathname,
    rel: "noreferrer noopener",
    target: "_blank"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Common_ProductName_ProductName_es_js__WEBPACK_IMPORTED_MODULE_10__/* .ProductName */ .r, {
    name: product.name || (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_11__.t)("T\xEAn s\u1EA3n ph\u1EA9m \u0111ang \u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt")
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SKU, null, "SKU: ", product.sku), product.gifts && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledProductGifts, {
    label: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_11__.t)("T\u1EB7ng ngay"),
    images: product.gifts.images
  })) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_11__.t)("Vui l\xF2ng ch\u1ECDn linh ki\u1EC7n"))), quantity && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCol, {
    col: 2
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_BuildPcNumberStepper_BuildPcNumberStepper_es_js__WEBPACK_IMPORTED_MODULE_12__/* .BuildPcNumberStepper */ .F, {
    onIncrease,
    onDecrease,
    setValue: setQuantity,
    value: quantity
  }), showDeleteButton && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButtonDelete, {
    level: 1,
    onClick: onDelete
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_11__.t)("X\xF3a"))), product && product.price && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCol, {
    col: 2
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPrice, __spreadValues({}, {
    price: product.price.latestPrice,
    discount: product.price.discountPercent,
    listedPrice: product.price.supplierRetailPrice
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCol, {
    col: 1.5
  }, product && product.showContact ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButton, {
    block: true,
    variant: "primary",
    tag: "a",
    href: "https://m.me/phongvuvietnam",
    marginBottom: 2,
    target: "_blank"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_11__.t)("Li\xEAn h\u1EC7")) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButton, {
    disabled: disableButton(),
    onClick,
    variant: "primary"
  }, actionText))));
};




/***/ }),

/***/ 260613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ BuildPcNumberStepper; }
/* harmony export */ });
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(650983);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(589561);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(580871);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);



const StyledStepper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ color }) => `
    display: flex;
    align-items: center;
    border-radius: 0.25rem;
    border: 1px solid ${color};
    align-items: center;
    overflow: hidden;
    background: #fff;
    justify-content: space-between;
  `);
const Value = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ color }) => `
    flex: 1;
    color: ${color};
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  `);
const StyledButton = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z)(({ color }) => `
    line-height: 1;
    color: ${color};
    font-size: 1rem;
    border: none;
    padding: 0;
    align-self: stretch;
    padding: 0.5rem;
    border-radius: 0;
    --button-icon-color: ${color};
`);
const Sign = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span`
  display: inline-block;
  width: 1rem;
  height: 1rem;
`;
const StyledInput = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Input */ .I)(({ color }) => `
  padding: 0;
  color: ${color};
  width: 2rem;
  border: none;
  text-align: center;
`);
const handleFocus = (event) => event.target.select();
const BuildPcNumberStepper = ({
  value,
  minimumValue,
  maximumValue,
  stepValue = 1,
  onIncrease,
  onDecrease,
  setValue,
  className,
  showDeleteIcon = true,
  variant = "primary",
  primaryColor
}) => {
  var _a, _b;
  const theme = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .F)();
  const color = variant === "primary" ? ((_a = theme.brand) == null ? void 0 : _a.primary) || primaryColor : theme.colors.dark;
  const borderColor = variant === "primary" ? ((_b = theme.brand) == null ? void 0 : _b.primary) || primaryColor : theme.colors.gray300;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledStepper, {
    className,
    color: borderColor
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButton, {
    color,
    outline: true,
    onClick: onDecrease,
    disabled: minimumValue ? value - stepValue < minimumValue : false,
    icon: value === 1 && showDeleteIcon ? {
      name: "trash",
      size: 16
    } : null
  }, (!showDeleteIcon || value > 1 || !value) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Sign, null, "-")), setValue ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, {
    type: "number",
    onChange: (e) => setValue(parseInt(e.target.value)),
    value,
    color,
    onFocus: handleFocus
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Value, {
    color
  }, value), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButton, {
    color,
    variant,
    outline: true,
    onClick: onIncrease,
    disabled: maximumValue ? value + stepValue > maximumValue : false
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Sign, null, "+")));
};




/***/ }),

/***/ 924780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ BuildPcSummary; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/i18n.es.js
var i18n_es = __webpack_require__(334751);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(855271);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Card/Card.es.js
var Card_es = __webpack_require__(797864);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/Button/Button.es.js
var Button_es = __webpack_require__(650983);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(179185);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/assets/images/empty_box.es.js
var EmptyBox = "https://shopfront-cdn.tekoapis.com/static/bd56488f2247217f.png";



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProductPrice/ProductPrice.es.js
var ProductPrice_es = __webpack_require__(770024);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/BuildPcSummary/BuildPcSummary.es.js






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCard = (0,styled_es/* styled */.z)(Card_es/* Card */.Z)`
  padding: 1rem 2rem;
  text-align: center;
`;
const Total = (0,styled_es/* styled */.z)(ProductPrice_es/* ProductPrice */.j)`
  min-height: unset;
  margin-left: 0.3rem;
  color: rgb(235, 33, 1);
  span {
    font-size: 1.25rem;
  }
`;
const Flex = styled_es/* styled.div */.z.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const StyledButton = (0,styled_es/* styled */.z)(Button_es/* Button */.z)`
  margin-top: 0.875rem;
`;
const Bold = styled_es/* styled.span */.z.span`
  font-weight: 500;
`;
const BuildPcSummary = (_a) => {
  var _b = _a, {
    total,
    selectedCount,
    onBuy,
    onAddToCart,
    addingToCart
  } = _b, props = __objRest(_b, [
    "total",
    "selectedCount",
    "onBuy",
    "onAddToCart",
    "addingToCart"
  ]);
  return /* @__PURE__ */ react.createElement(StyledCard, __spreadValues({}, props), selectedCount > 0 ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Flex, null, (0,i18n_es.t)("Chi ph\xED d\u1EF1 t\xEDnh:"), /* @__PURE__ */ react.createElement(Total, {
    price: total
  })), /* @__PURE__ */ react.createElement(StyledButton, {
    loading: addingToCart,
    onClick: onBuy,
    variant: "primary",
    block: true
  }, "Mua ngay"), /* @__PURE__ */ react.createElement(StyledButton, {
    loading: addingToCart,
    onClick: onAddToCart,
    variant: "tertiary",
    block: true
  }, /* @__PURE__ */ react.createElement(Bold, null, (0,i18n_es.t)("Th\xEAm v\xE0o gi\u1ECF h\xE0ng")))) : /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, {
    height: 200,
    contain: true,
    src: EmptyBox
  }));
};




/***/ }),

/***/ 562194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ BuildPcTabs; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(650983);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46610);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(802705);
/* harmony import */ var _Common_MiniDropdown_MiniDropdown_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72217);
/* harmony import */ var _Common_ListTile_ListTile_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(469100);







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  display: flex;
  justify-content: space-between;
  a {
    text-decoration: unset;
  }
`;
const RightWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  display: flex;
  flex-direction: row;
`;
const StyledButton = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z)`
  margin-right: 0.5rem;
`;
const StyledListTile = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_Common_ListTile_ListTile_es_js__WEBPACK_IMPORTED_MODULE_3__/* .ListTile */ .x)`
  padding: 0.4rem 0.6rem;
  font-size: 0.875rem;
`;
const BuildPcTabs = (_a) => {
  var _b = _a, {
    onClickTab,
    onClickCompare,
    onResetConfig,
    lsActiveTab
  } = _b, props = __objRest(_b, [
    "onClickTab",
    "onClickCompare",
    "onResetConfig",
    "lsActiveTab"
  ]);
  const [activeTab, setActiveTab] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(lsActiveTab || 0);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, [0, 1, 2].map((tab) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButton, {
    variant: tab === activeTab ? "primary" : "normal",
    onClick: () => {
      setActiveTab(tab);
      onClickTab && onClickTab(tab);
    },
    key: tab
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("C\u1EA5u h\xECnh"), " ", tab + 1))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RightWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButton, {
    variant: "primary",
    onClick: onResetConfig
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("T\u1EA1o l\u1EA1i"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .RefreshOutlined */ .y, {
    color: "white",
    size: 16,
    style: { marginLeft: "0.5rem" }
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Common_MiniDropdown_MiniDropdown_es_js__WEBPACK_IMPORTED_MODULE_6__/* .MiniDropdown */ ._, {
    text: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("T\u1EA3i c\u1EA5u h\xECnh")
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledListTile, {
    leading: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .SvgIcon */ .l, {
      name: "pdf",
      size: 16
    }),
    onClick: () => window.print(),
    title: "PDF"
  })))));
};




/***/ }),

/***/ 465385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ LogoLoading; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(855271);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(179185);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/assets/images/loading.es.js
var loading = "https://shopfront-cdn.tekoapis.com/static/0aca01576f2159f6.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/Loading/LogoLoading.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled_es/* styled.div */.z.div((props) => `
    width: ${props.size}px;
    height: ${props.size}px;
    position: relative;
  `);
const Logo = (0,styled_es/* styled */.z)(LazyImage_es/* LazyImage */.w)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
const StyledLazyImage = (0,styled_es/* styled */.z)(LazyImage_es/* LazyImage */.w)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 3px;
  right: 0;
`;
const LogoLoading = (_a) => {
  var _b = _a, {
    size = 80,
    logo = ""
  } = _b, props = __objRest(_b, [
    "size",
    "logo"
  ]);
  return /* @__PURE__ */ react.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    size
  }), logo && /* @__PURE__ */ react.createElement(Logo, {
    width: size / 2,
    height: size / 2,
    src: logo
  }), /* @__PURE__ */ react.createElement(StyledLazyImage, {
    width: size,
    height: size,
    src: loading
  }));
};




/***/ }),

/***/ 72217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ MiniDropdown; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(708966);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  position: relative;
`;
const StyledButtonChevron = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .ButtonChevron */ .y)`
  background: #fff;
  width: 100%;
  border: 1px solid #e0e0e0;
  line-height: unset;
  &:hover {
    background: #f3f3f3;
    border: 1px solid #e0e0e0;
  }
`;
const DropdownMenu = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  position: absolute;
  width: 100%;
  top: 2rem;
  left: 0;
  z-index: 1000;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  overflow: hidden;
`;
const MiniDropdown = (_a) => {
  var _b = _a, {
    text,
    children
  } = _b, props = __objRest(_b, [
    "text",
    "children"
  ]);
  const [dropdownOpen, setDropdownOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [endDelay, setEndDelay] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (dropdownOpen) {
      setTimeout(() => {
        setEndDelay(true);
      }, 200);
    } else {
      setEndDelay(false);
    }
  }, [dropdownOpen, endDelay]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    onMouseEnter: () => setDropdownOpen(true),
    onMouseLeave: () => setDropdownOpen(false)
  }, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButtonChevron, {
    direction: dropdownOpen ? "up" : "down"
  }, text), dropdownOpen && endDelay && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DropdownMenu, {
    onClick: () => setDropdownOpen(false)
  }, children));
};




/***/ }),

/***/ 811850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ ProductGifts; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(179185);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46610);



const StyledProductGifts = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;
const Label = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ theme }) => `
  font-size: 0.6875rem;
  color: ${theme == null ? void 0 : theme.colors.gray130};
`);
const ImageWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  margin: 0 0.2rem;
  width: 30px;
  height: 30px;
`;
const PromotionIcon = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  margin: 0 0.2rem;
  box-sizing: content-box;
`;
const ProductGifts = ({
  label,
  images = [],
  className,
  voucherCount = 0
}) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledProductGifts, {
  className
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Label, null, label), images.map((image, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImageWrapper, {
  key: index
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .LazyImage */ .w, {
  src: image.src,
  height: 30,
  width: 30,
  border: true,
  borderRadius: 4,
  alt: image.alt,
  contain: true
}))), voucherCount > 0 && Array.from(Array(voucherCount).keys()).map((i) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PromotionIcon, {
    key: i
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .SvgIcon */ .l, {
    name: "promotion",
    size: 16,
    color: "#1435c3"
  }));
}));




/***/ }),

/***/ 73586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ProductName; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(173698);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductName = (_a) => {
  var _b = _a, {
    name,
    status,
    needManageStock,
    totalAvailableByStocks = 0,
    isFlashSelling = false,
    tag
  } = _b, props = __objRest(_b, [
    "name",
    "status",
    "needManageStock",
    "totalAvailableByStocks",
    "isFlashSelling",
    "tag"
  ]);
  const NameTag = StyledProductName.withComponent(tag ? tag : "div");
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(NameTag, __spreadProps(__spreadValues({}, props), {
    maxLines: totalAvailableByStocks > 0 && totalAvailableByStocks < 5 ? 2 : 3
  }), status && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTag, __spreadValues({}, __spreadProps(__spreadValues({}, status), { children: status.value, variant: "primary" }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledH3, null, name)), !isFlashSelling && needManageStock && totalAvailableByStocks > 0 && totalAvailableByStocks < 5 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RemainingProduct, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_1__.t)("Ch\u1EC9 c\xF2n {{totalAvailableByStocks}} s\u1EA3n ph\u1EA9m", {
    totalAvailableByStocks
  })));
};
const StyledProductName = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(({ maxLines = 3 }) => `
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${maxLines};
  font-size: 13px;
`);
const StyledTag = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Tag */ .V)(({ color }) => `
  margin-right: 0.2rem;
  background-color: ${color};
  padding: 1px 0.4rem;
  font-size: 13px;
  font-weight: 400;
  padding: 2px 8px;
  border-radius: 4px;
`);
const RemainingProduct = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  color: #d9852b;
  font-size: 0.75rem;
  margin-top: 2px;
  margin-bottom: 8px;
  line-height: 1rem;
`;
const StyledH3 = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.h3 */ .z.h3`
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
  display: inline;
`;




/***/ }),

/***/ 770024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ProductPrice; }
/* harmony export */ });
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(526439);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46610);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, ({ theme }) => `
  display: flex;
  justify-content: space-between;
  --button-icon-color: ${theme == null ? void 0 : theme.colors.green400};
  `);
const PriceWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  display: flex;
  flex-direction: ${(props) => props.horizontal ? "" : "column"};
  align-items: baseline;
`;
const Price = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Currency */ .F)((props) => {
  var _a, _b;
  return `
  margin-bottom: ${props.size === "lg" ? "0.5rem" : "0"};
  font-size: ${props.size === "md" ? "1rem" : "1.75rem"};
  font-weight: 500;
  color: ${(_b = (_a = props.theme) == null ? void 0 : _a.brand) == null ? void 0 : _b.primary};
  font-weight: bold;
`;
});
const DiscountWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
const ListedPrice = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Currency */ .F)(({ lineThrough, theme, size, horizontal }) => `
  text-decoration: ${lineThrough ? "line-through" : "none"};
  color: ${theme.colors.gray130};
  font-size: ${size === "md" ? "0.75rem" : "1.25rem"};
  margin-left: ${horizontal ? "6px" : ""};
`);
const Discount = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.span */ .z.span(({ theme }) => {
  var _a;
  return `
  font-size: 0.75rem;
  color: ${(_a = theme == null ? void 0 : theme.brand) == null ? void 0 : _a.secondary};
  margin-left: 6px;
`;
});
const EditIcon = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .SvgIcon */ .l)(({ theme }) => `
    width: 1.25rem;
    height: 1.25rem;
    margin-left: 0.25rem;
    background-color: ${theme == null ? void 0 : theme.colors.link500};
  `);
const PriceEditIcon = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  display: flex;
  flex-direction: row;
`;
const ProductPrice = (_a) => {
  var _b = _a, {
    price,
    discount,
    horizontal = false,
    size = "md",
    className,
    unitPrice,
    listedPrice,
    consultationServiceFee = 0,
    isPriceEditable = false,
    onEditPrice
  } = _b, props = __objRest(_b, [
    "price",
    "discount",
    "horizontal",
    "size",
    "className",
    "unitPrice",
    "listedPrice",
    "consultationServiceFee",
    "isPriceEditable",
    "onEditPrice"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    className
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PriceWrapper, {
    horizontal
  }, price !== null && price !== void 0 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PriceEditIcon, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Price, {
    className: "price",
    size,
    value: price
  }), isPriceEditable && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(EditIcon, {
    name: "edit",
    onClick: onEditPrice
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DiscountWrapper, null, unitPrice && unitPrice !== price - consultationServiceFee && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListedPrice, {
    className: "listed-price",
    horizontal,
    size,
    value: unitPrice,
    lineThrough: true
  }), !!listedPrice && listedPrice !== price && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListedPrice, {
    className: "listed-price",
    horizontal,
    size,
    value: listedPrice,
    lineThrough: !!listedPrice && listedPrice !== price
  }), !!discount && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Discount, {
    className: "discount"
  }, discount))));
};




/***/ })

}]);